import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Layout from '@/components/Layout.vue'
import Home from '@/views/Home.vue'
import OtherPage from '@/views/OtherPage.vue'
import PowerPage from '@/views/PowerPage.vue'
import CardPage from '@/views/CardPage.vue'
import ProxyPage from '@/views/ProxyPage.vue'
import RoomPage from '@/views/RoomPage.vue'
import GenCardPage from '@/views/GenCardPage.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history', // 可选
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      component: Layout, // 使用公共布局
      children: [
        {
          path: '', // 默认子路由
          name: 'home',
          component: Home
        },
        {
          path: 'other',
          name: 'OtherPage',
          component: OtherPage
        },
        {
            path: 'power',
            name: 'PowerPage',
            component: PowerPage
        },
        {
            path: 'card',
            name: 'CardPage',
            component: CardPage
        },
        {
            path: 'room',
            name: 'RoomPage',
            component: RoomPage
        },
        {
            path: 'proxy',
            name: 'ProxyPage',
            component: ProxyPage
        },
        {
          path: 'gencard',
          name: 'GenCardPage',
          component: GenCardPage
      }
        // 你可以继续加其它页面
      ]
    }
  ]
})

// ✅ 【全局前置守卫】
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token') // 这里可以换成你自己的标识

  if (to.path === '/login') {
    // 访问登录页，直接放行
    next()
  } else {
    // 访问其他页面
    if (token) {
      // 有 token，已登录，放行
      next()
    } else {
      // 没 token，未登录，强制跳回登录页
      next('/login')
    }
  }
})

export default router